import fasEnchante1 from "./fas-enchante (1).webp";
import fasEnchante2 from "./fas-enchante (2).webp";
import fasEnchante3 from "./fas-enchante (3).webp";
import fasEnchante4 from "./fas-enchante (4).webp";

const fasenchante = [fasEnchante1, fasEnchante2, fasEnchante3, fasEnchante4];

export default fasenchante;
